let usage = `
<Menu
  :items="items"
  @item:click="menuClick"
/>
`.slice(1);

export default {
  usage
};
